module.exports = __webpack_public_path__ + "static/media/habanero.c889e70d.jpeg";